import { Component, OnInit, Input, ChangeDetectionStrategy, Type } from '@angular/core';
import { DomainService } from 'app/core/services/domain.service';
import { Observable } from 'rxjs/Observable';
import { LicenseService } from 'app/core/services/license.service';
import { platform } from 'os';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { Subject } from 'rxjs/Subject';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { ContentUpdatedInfoComponent } from 'app/shared/components/modal/content-updated-info.component';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';

@Component({
  selector: 'itpx-deliverable-stack-presentation',
  templateUrl: './deliverable-stack-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliverableStackPresentationComponent extends LoadingPage implements OnInit {

  sharedDeliverable$: Observable<any[]>;
  status$ = new Subject<any>();
  @Input() deliverables$: Observable<any[]>;
  private sharedProfile$: Observable<any>;
  private openModal = new Subject<any>();

  constructor(private licenseService: LicenseService,
    private profileService: ProfileService,
    private modalService: SmartModalService
  ) { super(); }

  ngOnInit() {
    this.sharedDeliverable$ = this.deliverables$.shareReplay(1);
    this.sharedProfile$ = this.profileService.getProfile().shareReplay(1);
    this.sharedDeliverable$.bindToLifecycle(this).subscribe(data => {
      data.forEach(val => {
        // console.log({ id: val.id, status: val.status });
        this.status$.next({ id: val.id, status: val.status });
      })
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-stack-presentation/deliverable-stack-presentation.component.ts